import { render } from "./FrameBase.vue?vue&type=template&id=a5332942"
import script from "./FrameBase.vue?vue&type=script&lang=js"
export * from "./FrameBase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__